
<template>
  <div class="modal-container">
    <detail-header
      :formDataObj="formData"
      :isSubmit="isSubmit"
      :isEdit="true"
      :pcdType="1"
      @payObj="getPayObj"
      @isErrMap="getIsErrMap"
      :isLoaded="isLoaded"
      :isHasDo="true"
    ></detail-header>
    <div class="add-box clearfix">
      <table-header
        @add="insertEvent"
        @remove="removeEvent"
        @copy="copyEvent"
      ></table-header>
      <vxe-table
        border
        show-overflow
        keep-source
        class="table-style"
        ref="xTable"
        highlight-hover-row
        max-height="270"
        :data="tableData"
        :edit-rules="editRules"
        :auto-resize="true"
        :edit-config="{ trigger: 'click', mode: 'row', showIcon: false }"
        @cell-click="cellClickEvent"
        @scroll="$refs.xTable.clearValidate()"
        :show-footer="true"
        :footer-method="footerMethod"
        :footer-cell-class-name="footerCellClassName"
      >
        <vxe-table-column
          width="50"
          align="center"
          type="checkbox"
        ></vxe-table-column>

        <vxe-table-column
          width="60"
          align="center"
          field="index"
          title="序号"
          v-if="isImport"
        ></vxe-table-column>
        <vxe-table-column
          type="seq"
          width="60"
          align="center"
          title="序号"
          v-else
        ></vxe-table-column>

        <vxe-table-column
          field="ordersNumb"
          width="150"
          title="关联订单"
          align="center"
        >
          <template v-slot="{ row }">
            <div
              :class="{ 'link-text': canInsert }"
              @click="openOrderModal(row)"
            >
              <span>
                <em v-if="row.ordersBuyerAmountList && row.ordersBuyerAmountList.length > 1"
                  >查看关联订单</em
                >
                <em v-else-if="row.ordersBuyerAmountList && row.ordersBuyerAmountList.length == 1">{{
                  row.ordersBuyerAmountList[0].ordersNumb
                }}</em>
                <em v-else>选择关联订单</em>
              </span>
            </div>
          </template>
          <!-- <template v-slot="{ row }">
            <div
              :class="{ 'link-text': canInsert }"
              @click="openOrderModal(row)"
            >
              {{
                row.ordersNumb == null || row.ordersNumb == ""
                  ? "选择关联订单"
                  : row.ordersNumb
              }}
            </div>
          </template> -->
        </vxe-table-column>

        <!-- 2020-09-18 新增 所属公司 业务员 客户名称-->
        <vxe-table-column
          field="salesMan"
          width="105"
          title="业务员"
          align="center"
        >
          <template v-slot="scope">
            <div>
              <div v-if="!canInsert || scope.row.isOrderSalesMan">
                {{ scope.row.salesMan }}
              </div>
              <sales-man
                v-else
                :row="scope.row"
                :field="'salesMan'"
              ></sales-man>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="clientName"
          width="150"
          title="客户名称"
          align="center"
        >
          <template v-slot:header="{ column }">
            <span class="column-title"
              >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
          <template v-slot="{ row }">
            <div
              class="link-text"
              @click="openChooseAccount(row, 'clientName')"
            >
              {{ row.clientName ? row.clientName : "选择客户" }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="200"
          field="compName"
          title="所属方"
          align="center"
        >
          <template v-slot:header="{ column }">
            <span class="column-title"
              >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
          <template v-slot="scope">
            <platform-corp
              :row="scope.row"
              :field="'compName'"
              :placeholder="'请选择平台企业'"
              @select="$refs.xTable.updateStatus(scope)"
              @update="selectCompName"
              :autoSave="false"
              v-if="canInsert"
            ></platform-corp>
            <div v-else>{{ scope.row.compName }}</div>
          </template>
        </vxe-table-column>

        <vxe-table-column width="150" field="payAmount" title="金额">
          <template v-slot:header="{ column }">
            <span class="column-title"
              >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
          <template v-slot="scope">
            <vxe-input
              v-model="scope.row.payAmount"
              v-on:input="inputPayAmountEvent(scope.row)"
              @input="$refs.xTable.updateStatus(scope)"
              placeholder="必填"
              type="number"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="120" field="addTime" title="日期">
          <template v-slot:header="{ column }">
            <span class="column-title"
              >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.addTime"
              placeholder="请选择"
              type="date"
              :editable="false"
              :disabled="payType === 0"
              prefix-icon
              transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column width="150" field="note" title="摘要">
          <template v-slot:header="{ column }">
            <span class="column-title"
              >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
          <template v-slot="{ row }">
            <vxe-input
              v-model="row.note"
              placeholder="必填"
              maxlength="200"
            ></vxe-input>
          </template>
        </vxe-table-column>

        <!-- 平台跟托运人往来的收款  开始 -->
        <vxe-table-column
          width="200"
          field="recName"
          title="收款企业(人)名称"
          class-name="link-text"
          v-if="cate === 'Collection'"
        >
          <template v-slot:header="{ column }">
            <span class="column-title"
              >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
          <template v-slot="{ row, $rowIndex }">
            <div
              class="link-text"
              @click="openBankAccountModal(row, 'recName', 'platform', $rowIndex)"
            >
              {{
                row.recName == null ||
                row.recName == "" ||
                row.recName == "null"
                  ? "选择平台银行账户"
                  : row.recName
              }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="150"
          field="recBank"
          title="开户行"
          v-if="cate === 'Collection'"
        >
          <template v-slot:header="{ column }">
            <span class="column-title"
            >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="150"
          field="recAccount"
          title="银行卡号"
          v-if="cate === 'Collection'"
        >
          <template v-slot:header="{ column }">
            <span class="column-title"
            >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
        </vxe-table-column>

        <vxe-table-column
          width="200"
          field="paymentsName"
          title="付款企业(人)名称"
          v-if="cate === 'Collection'"
        >
          <template v-slot:header="{ column }">
            <span class="column-title"
              >{{ column.title }} <i style="color: #f00"> * </i></span
            >
          </template>
          <!-- <template v-slot="{ row }">
            <vxe-input
              v-model="row.paymentsName"
              placeholder="必填"
            ></vxe-input>
          </template> -->
          <template v-slot="{ row, $rowIndex }">
            <div
              class="link-text"
              @click="openBankAccountModal(row, 'paymentsName', 'user', $rowIndex)"
            >
              {{
                row.paymentsName == null ||
                row.paymentsName == "" ||
                row.paymentsName == "null"
                  ? "选择用户银行账户"
                  : row.paymentsName
              }}
            </div>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column
          width="150"
          field="payBank"
          title="开户行"
          v-if="cate === 'Collection'"
        ></vxe-table-column>
        <vxe-table-column
          width="150"
          field="payAccount"
          title="银行卡号"
          v-if="cate === 'Collection'"
        ></vxe-table-column> -->

        <!-- 平台跟托运人往来的收款 结束 -->
        <vxe-table-column width="150" field="payBankCode" title="支付流水号">
          <template v-slot="{ row }">
            <vxe-input v-model="row.payBankCode" placeholder="选填" :disabled="payType === 0"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          width="150"
          field="fileList"
          title="上传附件"
          align="center"
        >
          <template v-slot="{ row }">
            <upload-list
              :row="row"
              :initFileList="row.fileList"
              :view="'packup'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div>
        <vxe-table
          border
          show-overflow
          keep-source
          ref="fileTable"
          :data="uploadData"
          class="table-upload-style"
          max-height="140"
          :auto-resize="true"
          :edit-config="{ trigger: 'click', mode: 'cell', showIcon: false }"
        >
          <vxe-table-column field="fileList" title="附件">
            <template v-slot="{ row }">
              <div style="padding: 5px 0">
                <upload-list
                  :row="row"
                  :view="'arrange'"
                  ref="uploadList"
                ></upload-list>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>

      <div class="footer-wrap">
        <Button
          type="primary"
          @click="impotEvent"
          v-if="isImport || isCurImport"
          >上传导入文件</Button
        >
        <Button status="primary" @click="submitEvent">提交</Button>
        <Button
          type="primary"
          @click="showTempModal"
          v-if="
            isHavePermission('payments:createPaymentsBuyer') &&
            !isCurImport &&
            !isImport
          "
          >批量导入</Button
        >
      </div>

      <!-- 弹窗 -->
      <!-- 选择关联订单 -->
      <vxe-modal
        v-model="isShowChooseOrder"
        width="1300"
        height="700"
        resize
        remember
        title="选择订单"
      >
        <choose-order
          :chainId="chainId"
          @choose="chooseOrderEvent"
          ref="refPaymentAboutOrder"
        ></choose-order>
      </vxe-modal>

      <!-- 选择企业 -->
      <vxe-modal
        v-model="isShowChooseAccount"
        width="800"
        height="600"
        resize
        remember
        title="选择客户"
      >
        <choose-account
          @choose="chooseAccountEvent"
          ref="chooseAccount"
        ></choose-account>
      </vxe-modal>

      <!-- 选择银行账户 -->
      <vxe-modal
        v-model="isShowBankAccountModal"
        width="900"
        height="600"
        resize
        remember
        :title="bankAccountModalTitle"
        :showHeader="false"
      >
        <bank-account
          @close="closeBankAccount"
          @choose="chooseBankAccount"
          :isShow="isShowBankAccountModal"
          ref="bankAccountModal"
        ></bank-account>
      </vxe-modal>
      <vxe-modal
        v-model="templateVisible"
        title="款项收入流程导入"
        width="1000"
        height="650"
        @close="closeTemplate"
        remember
      >
        <import
          @goImport="goImport"
          @close="closeTemplate"
          ref="modalTemplate"
        ></import>
      </vxe-modal>
      <vxe-modal
      v-model="isShowOnlineChooseOrder"
      width="1300"
      height="700"
      resize
      remember
      title="选择订单"
    >
      <choose-order-online
        @choose="chooseOrderOnlineEvent"
        :isOnlyBuyer ="true"
        ref="refPaymentAboutOrderOnline"
      ></choose-order-online>
    </vxe-modal>
    <vxe-modal
      v-model="isShowFinance"
      width="800"
      height="600"
      resize
      remember
      title="选择子账户"
    >
      <finance-account
        @choose="chooseFinanceAccount"
        ref="financeAccount"
      ></finance-account>
    </vxe-modal>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import $api from '@/apiProvider'
import UploadList from '@/components/common/UploadList'
import Account from '@/components/modal/Account'
import BankAccount from '@/components/modal/BankAccount'
import {
  getExcelTime,
  hideLoading,
  isEmpty,
  isNotEmpty,
  paymentFooter,
  showFailMsgList,
  showLoading
} from '@/utils/util'
import TableHeader from '@/components/common/TableHeader'
import SalesMan from '@/components/common/SalesMan'
import PlatformCorp from '@/components/common/PlatformCorp'
import CustomerSelect from '@/components/common/CustomerSelect'
import getAuthOrization from "@/mixin/getAuthOrization";
import AboutCollectionOrder from "@/components/order/AboutCollectionOrder";
import DetailHeader from "@/views/procedure/DetailHeader";
import Import from "@/components/common/Import"; // 导入
import ChooseOrderOnline from "@/components/order/PayAboutOrder";
import FinanceAccount from "@/components/modal/FinanceAccount";
import {
  apiRequest
} from "@/utils/api";

const assign = (o) => Object.assign({}, o)

export default {
  mixins: [getAuthOrization],
  name: 'CreateCollection',
  components: {
    PlatformCorp,
    SalesMan,
    TableHeader,
    ChooseOrder: AboutCollectionOrder,
    UploadList,
    BankAccount,
    ChooseAccount: Account,
    DetailHeader,
    Import,
    ChooseOrderOnline,
    FinanceAccount
  },
  props: {
    cate: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: false
    },
    isImport: {
      type: Boolean,
      default: false
    },
    chainId: {
      type: Number,
    }
  },
  data() {
    return {
      createAction: '',
      canInsert: true,
      isShowChooseOrder: false,
      isShowOnlineChooseOrder: false,
      //选择银行账户
      isShowBankAccountModal: false,
      bankAccountModalTitle: '选择银行账户',

      isShowChooseAccount: false, // 选择客户

      amountListName: '', //关联订单的字段名
      dataTmp: {
        index: '',
        "ordersNumb": null,
        "addTime": '',
        "fileUuidList": [],
        "fileList": [],
        "note": null,
        "operUser": null,
        "ordersBuyerAmountList": [],
        "ordersSellerAmountList": [],
        "ordersSellerLv2sAmountList": [],
        "payAccount": null,
        "payAmount": "",
        "payBank": null,
        "payBankCode": null,
        "paymentsName": null,
        "recAccount": null,
        "recBank": null,
        "recName": null,
        "unusedAmount": 0,
        "usedAmount": 0,
        compName: '',
        isOrderCompName: false,
        salesMan: '',
        isOrdersalesMan: false,
        clientName: '',
        isOrderClientName: false

      },
      tableData: [],
      editRules: {
        clientName: [{
          validator: this.requireValid
        }],
        // ordersNumb: [{
        //     validator: this.requireValid
        // }],
        // salesMan: [{
        //     validator: this.requireValid
        // }],
        compName: [{
          validator: this.requireValid
        }],
        // clientName: [{
        //     validator: this.requireValid
        // }],
        payAmount: [{
          validator: this.requireValid
        }],
        addTime: [{
          validator: this.requireValid
        }],
        note: [{
          validator: this.requireValid
        }],
        paymentsName: [{
          validator: this.requireValid
        }],
        recName: [{
          validator: this.requireValid
        }],
        recBank: [{
          validator: this.requireValid
        }],
        recAccount: [{
          validator: this.requireValid
        }],
      },
      platformCompMap: null,
      flowTempletId: 1,
      formData: {},
      isSubmit: false,
      isErrMap: true,
      isLoaded: false,
      isCurImport: false,
      templateVisible: false,
      isinitByOrder: false,
      uploadData: [{
        fileList: null,
      },],
      payType: 1,
      isShowFinance: false,
      fromOrigin: null,
      orderInfo: null,
      isInitByOrder: null,
    };
  },
  watch: {
    isShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val == false && oldVal == true) {
          if (isNotEmpty(this.$refs.xTable)) {
            this.$refs.xTable.clearValidate()
            this.updateFooterEvent()
          }
          this.payType = 1;
          this.tableData = [];
          this.uploadData = [];
          let fileObj = {
            fileList: null,
          };
          this.uploadData.push(fileObj);
          this.$refs.uploadList.init();
          this.canInsert = true;
          this.isSubmit = false;
          this.isLoaded = false;
          this.isCurImport = false;
          this.isinitByOrder = false;

        }
        if (val == true) {
          this.insertEvent()
          this.getFlowData()
        }
      }
    },
    cate: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        switch (val) {
          case 'Collection':
            this.amountListName = 'ordersBuyerAmountList'
            this.createAction = 'createPaymentsBuyer'
            break
          case 'Payment':
            this.amountListName = 'ordersSellerAmountList'
            this.createAction = 'createPaymentsSeller'
            break
          case 'SellerPayment':
            this.amountListName = 'ordersSellerLv2sAmountList'
            this.createAction = 'createPaymentsSellerLv2'
            break
        }
      }
    },
    payType: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val !== oldVal && oldVal !== undefined) {
          this.changeType();
        }
      },
    },
  },
  methods: {
    getFlowData() {
      let obj = {
        flowTempletId: this.flowTempletId
      };
      $api.flowInstance.createFlowModel
          .GET({
            params: obj,
          })
          .then((res) => {
            if (res.status === 1) {
              this.formData = res.data;
              this.isLoaded = true
            } else {
              this.$XModal.confirm(res.message).then(() => {
                this.$emit('close')
              })
            }
          });
    },
    getPayObj(val) {
      this.formData = val;
      this.payType = val.type;
    },
    changeType() {
      this.$refs.xTable.remove();
      if (this.fromOrigin === "chain") {
        this.initByChainId(this.chainId);
        // this.insertEvent();
      } else if (this.fromOrigin === "order") {
        this.initByOrderInfo(this.orderInfo);
      } else {
        this.insertEvent();
      }
    },
    getIsErrMap(val) {
      this.isErrMap = val
    },
    async initByChainId(chainId) {
      this.fromOrigin = "chain";
      let res = await this.getBuyerOrderInfoByChainId(chainId);
      if (null != res) {
        this.initByOrderInfo(res);
      }
    },
    //查托运人订单
    async getBuyerOrderInfoByChainId(chainId) {
      let orderInfo = null;
      let res = await $api.order.post("queryOrdersBuyerList", {
        chainId: chainId,
        page: 1,
      });
      if (res.status == 1 && res.data.rows.length > 0) {
        let orderRes = await $api.order.post("queryOrdersBuyerDetail", {
          id: res.data.rows[0].id,
        });
        if (orderRes.status == 1) {
          orderInfo = orderRes.data;
        }
      }
      return orderInfo;
    },
    initByOrderInfo(orderInfo) {
      console.log('创建收付款 通过 订单号初始化 - 开始', orderInfo, this.cate)
      this.orderInfo = orderInfo;
      this.fromOrigin = "order";
      this.isinitByOrder = true
      this.insertEvent()
      this.currentRow = this.$refs.xTable.getTableData().tableData[0]
      //托运人 承运人 取订单号
      orderInfo.ordersNumb = this.cate === 'Collection' ? orderInfo.buyerOrdersNum : orderInfo.sellerOrdersNum
      orderInfo.ordersId = orderInfo.id
      orderInfo.id = null
      if (this.payType === 1) {
        this.chooseOrderEvent([orderInfo], 0)
      } else {
        this.chooseOrderOnlineEvent([orderInfo], 0)
      }

      if (isNotEmpty(orderInfo.platformCompanyId)) {
        this.currentRow.compName = orderInfo.platformCompany
        this.currentRow.platformCompanyId = orderInfo.platformCompanyId
      }
      if (isNotEmpty(orderInfo.salesMan)) {
        this.currentRow.salesMan = orderInfo.salesManName
        this.currentRow.salesManId = orderInfo.salesMan
      }
      this.$refs.xTable.reloadData([this.currentRow])
      this.canInsert = false
      console.log('创建收付款 通过 订单号初始化 - 结束', this.cate, this.currentRow)
    },
    initByCate(cate) {
      this.fromOrigin = "cate";
      console.log(this.cate, cate)
    },
    async requireValid(e) {
      // if (e.columnIndex == 4 && isEmpty(e.row.clientName)) {
      //     return Promise.reject(new Error('请先选择客户名称'))
      // }
      if (e.columnIndex == 5 && isEmpty(e.row.compName)) {
        return Promise.reject(new Error('请先选择所属公司'))
      }
      if (e.columnIndex == 6 && isEmpty(e.row.payAmount) && this.payType === 1) {
        return Promise.reject(new Error('请先填写付款金额'))
      }
      if (isNotEmpty(e.row.compName) && e.row.aboutAmount > 0 && e.columnIndex == 2 && this.isImport && isEmpty(e.row.ordersNumb)) {
        return Promise.reject(new Error('导入必须填写订单号'))
      }
      if (isEmpty(e.cellValue)) {
        if (e.columnIndex == 2 && !this.isImport || e.columnIndex < 6 && !(e.row.payAmount > 0) || isEmpty(e.row.compName) || (e.column.title == "日期" && this.payType === 0)) {
          console.log('优先验证金额 或者 公司')
        } else {
          return Promise.reject(new Error(e.column.title + '必填'))
        }
      }
    },
    showTempModal() {
      this.$refs.modalTemplate.setExport('707托运人付款信息导入模板.xls');
      this.templateVisible = true;
    },
    closeTemplate() {
      this.templateVisible = false;
    },
    goImport() {
      this.isShowCreateInvoice = true
      this.isCurImport = true;
      this.templateVisible = false;
    },

    async impotEvent() {
      await this.initPlatCompMap()
      this.$refs.xTable.readFile({
        types: ['xls', 'xlsx']
      }).then(evnt => {
        showLoading()
        const tableData = [];
        const files = evnt.target.files;
        const fileReader = new FileReader();
        fileReader.onload = (ev) => {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
          // 解析数据
          let xlsxData = csvData.split('\n');
          //删除xlsx列名
          xlsxData.splice(0, 1);
          xlsxData.forEach((vRow) => {
            if (vRow) {
              const vCols = vRow.split(',');
              let item = {
                index: vCols[0], //需要
                ordersNumb: vCols[1], //承运人订单号
                salesMan: vCols[2],
                clientName: vCols[3],
                isOrderCompName: false,
                isOrdersalesMan: false,
                compName: vCols[4],
                isOrderClientName: false,
                payAmount: vCols[5], //付款金额
                addTime: getExcelTime(vCols[6]), //收款日期
                note: vCols[7], //摘要
                recName: vCols[8], //收款企业（人）名称
                recBank: vCols[9], //开户行
                recAccount: vCols[10], //银行卡号
                paymentsName: vCols[11], //付款企业（人）名称
                payBankCode: vCols[12], //支付凭证流水号
              };
              item[this.amountListName] = [{
                ordersNum: item.ordersNumb,
                ordersNumb: item.ordersNumb,
                aboutAmount: item.payAmount
              }]
              item.platformCompanyId = this.platformCompMap[item.compName]
              tableData.push(item);
            }
          })
          this.tableData = tableData;
          this.updateFooterEvent()
          setTimeout(() => {
            hideLoading();
          }, 1000);
        }
        fileReader.readAsBinaryString(files[0]);
      })
    },
    insertEvent() {
      if (isEmpty(this.$refs.xTable)) return
      let tableData = this.$refs.xTable.getTableData().tableData
      this.$refs.xTable.clearValidate()
      let record = assign(this.dataTmp)
      if (this.isinitByOrder) {
        //不能新增的情况下 都是复制第一条的
        if (tableData.length > 0) {
          let amountList = [assign(tableData[0][this.amountListName][0])]
          if (this.payType === 1) {
            record = Object.assign(record, {
              ordersNumb: tableData[0].ordersNumb, //承运人订单号
              ordersId: tableData[0].ordersId,
              salesMan: tableData[0].salesMan,
              salesManId: tableData[0].salesManId,
              compName: tableData[0].compName,
              clientName: tableData[0].clientName,
              platformCompanyId: tableData[0].platformCompanyId,
              [this.amountListName]: amountList
            })
          } else {
            record = Object.assign(record, {
              ordersNumb: tableData[0].ordersNumb, //承运人订单号
              ordersId: tableData[0].ordersId,
              salesMan: tableData[0].salesMan,
              salesManId: tableData[0].salesManId,
              compName: tableData[0].compName,
              clientName: tableData[0].clientName,
              platformCompanyId: tableData[0].platformCompanyId,
              [this.amountListName]: amountList,
              paymentsName: tableData[0].paymentsName,
              payCompName: tableData[0].payCompName,
              payBank: tableData[0].payBank,
              // paymentsName: tableData[0].paymentsName,
              payAccount: tableData[0].payAccount,
              recBank: tableData[0].recBank,
              recName: tableData[0].recName,
              recAccount: tableData[0].recAccount,
              recCompName: tableData[0].recCompName
            })
          }
        }
      }
      record.index = tableData.length + 1
      record.fileList = []
      record.fileUuidList = []
      this.$refs.xTable.insertAt(record, -1)
      this.$refs.xTable.updateStatus()
      this.updateFooterEvent()
    },
    async removeEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords()
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: '没有选择'
        })
        return
      }
      if (!this.canInsert) {
        //不能全部删除
        if (checkboxRecords.length == this.$refs.xTable.getTableData().tableData.length) {
          this.$XModal.message({
            message: '不能全部删除,至少保留一条'
          })
          return
        }
      }
      let confirmRes = await this.$XModal.confirm(
          "删除后不可恢复",
          "是否删除？"
      );
      if (confirmRes == 'confirm') {
        this.$refs.xTable.removeCheckboxRow()
        this.$refs.xTable.updateStatus()
      }
    },
    copyEvent() {
      let checkboxRecords = this.$refs.xTable.getCheckboxRecords()
      if (isEmpty(checkboxRecords)) {
        this.$XModal.message({
          message: '没有选择'
        })
        return
      }
      let newRecords = []
      checkboxRecords.forEach(item => {
        let newItem = assign(item)
        //自主添加收付款的时候不复制关联的订单
        let newAmountList = []
        if (!this.canInsert) {
          newItem[this.amountListName].forEach(i => {
            newAmountList.push(assign(i))
          })
        } else {
          newItem.ordersNumb = ''
        }
        newItem[this.amountListName] = newAmountList
        newRecords.push(assign(newItem))
      })
      this.$refs.xTable.insertAt(newRecords, -1)
      this.$refs.xTable.updateStatus()
    },
    cellClickEvent(e) {
      this.$refs.xTable.clearValidate()
    },
    async selectCompName(row, id, name) {
      if (isNotEmpty(row.compName) && row.compName != name && isNotEmpty(row[this.amountListName])) {
        let confirmRes = await this.$XModal.confirm(
            "更换所属平台公司将清空关联订单",
            "是否更换"
        );
        if (confirmRes === "confirm") {
          row[this.amountListName] = []
          row.ordersNumb = ''
        } else {
          return
        }
      }
      row.platformCompanyId = id
      row.compName = name
      // 选择平台清空收付款信息
      if (this.payType === 0) {
        row.paymentsName = null;
        row.payBank = null;
        row.payAccount = null;
        row.recBank = null;
        row.recName = null;
        row.recAccount = null;
        row.payCompName = null;
        row.recCompName = null;
      }
    },
    async openOrderModal(row) {
      let cate = "Collection";
      this.currentRow = row;
      if (this.payType === 0) {
        // 线上
        if (
            isNotEmpty(row.compName) ||
            this.isInitByOrder == "buyer" ||
            this.fromOrigin === "chain"
        ) {
          this.isShowOnlineChooseOrder = true;
          this.$refs.refPaymentAboutOrderOnline.init(
              this.type,
              cate,
              0,
              row.payAmount,
              row[this.amountListName],
              this.chainId,
              row.compName,
              row.platformCompanyId
          );
        } else {
          await this.$refs.xTable.clearValidate();
          await this.$refs.xTable.validate(row, (err) => {
          });
        }
      } else {
        // 线下
        if (isNotEmpty(row.payAmount)) {
          if (this.canInsert) {
            if (isEmpty(row.platformCompanyId)) {
              this.$XModal.message({
                message: "所属平台公司名称错误"
              })
              return
            }
            // this.currentRow = row
            this.isShowChooseOrder = true
            this.$refs.refPaymentAboutOrder.init(this.cate, 0, row.payAmount, row[this.amountListName], row.platformCompanyId, row.clientName)
          }
        } else {
          await this.$refs.xTable.clearValidate()
          await this.$refs.xTable.validate(row, (err) => {
          })
        }
      }

    },
    async chooseOrderOnlineEvent(amountList, usedAmount) {
      this.isShowOnlineChooseOrder = false
      this.$refs.xTable.clearValidate("ordersNumb");
      this.currentRow.platformCompanyId = amountList[0].platformCompanyId;
      this.currentRow.buyerName = amountList[0].platformCompany;
      this.currentRow.compName = amountList[0].platformCompany;
      this.currentRow.platformCompany = amountList[0].platformCompany;
      this.currentRow.platformCompanyId = amountList[0].platformCompanyId;
      // 重新选择订单 LIST 清空
      this.currentRow.ordersBuyerAmountList = [];
      this.currentRow.ordersSellerAmountList = [];
      this.currentRow.ordersSellerLv2sAmountList = [];
      this.currentRow.ordersList = [];
      let amountListName;
      // console.log(amountList);
      // debugger
      amountList.forEach((item) => {
        let firWord = item.ordersNumb.substr(0, 1);
        let ordersType;
        if (firWord == "G") {
          amountListName = "ordersBuyerAmountList";
          ordersType = 1;
        } else if (firWord == "S") {
          amountListName = "ordersSellerAmountList";
          ordersType = 2;
        } else {
          amountListName = "ordersSellerLv2sAmountList";
          ordersType = 3;
        }
        let curRow = Object.assign(item, {
          ordersType,
          ordersNum: item.ordersNumb,
        });

        // 只选择一个订单，带入客户名称，业务员，佣金率
        if (amountList.length === 1) {
          this.currentRow.ordersNumb = amountList[0].ordersNumb;
          this.currentRow.salesMan = amountList[0].salesManName;
          if (isNotEmpty(amountList[0].rateManage)) {
            this.currentRow.commission = `${amountList[0].rateManage}`;
            this.currentRow.rateManage = `${amountList[0].rateManage}`;
          } else {
            this.currentRow.commission = null;
            this.currentRow.rateManage = null;
          }
          // 选择多条订单时不带入客户
          if (
              amountList[0].paymentType === 2 ||
              amountList[0].paymentType === 3 ||
              amountList[0].ordersType == 2 ||
              amountList[0].ordersType == 3
          ) {
            // 承运人订单客户为承运人,实际承运人订单为承运人
            this.currentRow.clientName = amountList[0].sellerName;
          } else {
            // 托运人订单客户为托运人， 实际承运人订单为托运人
            this.currentRow.clientName = amountList[0].buyerName;
          }
        } else {
          this.currentRow.ordersNumb = "";
        }

        // console.log(curRow);
        // debugger
        // let ordersListRow = Object.assign(item, { ordersNum: item.ordersNumb, ordersType });
        this.currentRow.ordersList.push(curRow);
        this.currentRow[amountListName].push(curRow);
      });
      // 选择订单重置银行信息
      this.currentRow.payBank = null;
      this.currentRow.paymentsName = null;
      this.currentRow.payAccount = null;
      this.currentRow.recBank = null;
      this.currentRow.recName = null;
      this.currentRow.recAccount = null;
      this.currentRow.payCompName = null;
      this.currentRow.recCompName = null;

      console.log("线上支付自动带入银行账户信息", this.currentRow);
      let path = "api/finance/";
      let action = "cebBusiMem/queryMemList";
      let params = {};
      params.busiSubjectId = this.platformCompanyId;
      // console.log(this.currentRow, "this.currentRow.ordersBuyerAmountList");
      if (isNotEmpty(this.currentRow.ordersBuyerAmountList)) {
        params.subjectId = this.currentRow.ordersBuyerAmountList[0].buyerId;
        amountList[0].paymentType = 1
      }
      // if (amountList && amountList[0].paymentType === 1) {
      //     params.subjectId = this.currentRow.ordersBuyerAmountList[0].buyerId;
      // } else if (amountList && amountList[0].paymentType === 2) {
      //     params.subjectId = this.currentRow.ordersSellerAmountList[0].buyerId;
      // } else if (amountList && amountList[0].paymentType === 3) {
      //     params.subjectId = this.currentRow.ordersSellerLv2sAmountList[0].buyerId;
      // }
      switch (amountList[0].paymentType) {
        case 1:
          params.subjectType = 1;
          break;
        case 2:
          params.subjectType = 0;
          break;
        case 3:
          params.subjectType = 1;
      }
      let res = await apiRequest(path, action, params);
      if (res.status === 1) {
        if (res.data.rows.length < 1) {
          this.$XModal.message({
            message: "付款企业或者个人未绑定子账户，请先绑定子账户",
          });
          return;
        } else {
          let arr = res.data.rows.filter((item) => {
            return item.busiSubjectName == this.currentRow.platformCompany;
          });
          this.currentRow.payBank = "光大银行";
          this.currentRow.paymentsName = arr[0].memName;
          this.currentRow.payCompName = arr[0].busiSubjectName;
          this.currentRow.payAccount = arr[0].subAcc;
        }
      }

      if (isNotEmpty(this.currentRow.ordersBuyerAmountList)) {
        params.subjectId = this.currentRow.ordersBuyerAmountList[0].sellerId;
        amountList[0].paymentType = 1
      }
      switch (amountList[0].paymentType) {
        case 1:
          params.subjectType = 0;
          break;
        case 2:
          params.subjectType = 1;
          break;
        case 3:
          params.subjectType = 1;
      }

      let redRes = await apiRequest(path, action, params);
      if (redRes.status === 1) {
        if (redRes.data.rows.length < 1) {
          this.$XModal.message({
            message: "收款企业或者个人未绑定子账户，请先绑定子账户",
          });
          return;
        } else {
          let arr = redRes.data.rows.filter((item) => {
            return item.busiSubjectName == this.currentRow.platformCompany;
          });
          //  console.log(arr[0]);
          // debugger
          // this.currentRow.recBank = redRes.data.rows[0].bindOpenBankName;
          this.currentRow.recBank = "光大银行";
          this.currentRow.recName = arr[0].memName;
          this.currentRow.recAccount = arr[0].subAcc;
          this.currentRow.recCompName = arr[0].busiSubjectName;
        }
      }

    },
    openChooseAccount(row, field) {
      this.isShowChooseAccount = true
      this.currentRow = row
      this.currentChooseColumn = field
      this.$refs.chooseAccount.init()
    },
    chooseAccountEvent(account, type) {
      console.log('chooseAccountEvent', account)
      // this.currentRow[this.currentChooseColumn] = type === 1 ? account.compName : account.realName;
      this.currentRow[this.currentChooseColumn] = account.userName;
      this.isShowChooseAccount = false
      this.$refs.xTable.clearValidate(this.currentChooseColumn)
    },
    chooseOrderEvent(amountList, usedAmount) {
      console.log('chooseOrderEvent', amountList, usedAmount)
      this.isShowChooseOrder = false
      this.$refs.xTable.clearValidate('ordersNumb')

      //关联订单数据
      this.currentRow.usedAmount = usedAmount
      this.currentRow[this.amountListName] = amountList
      if (amountList.length > 0) {
        this.currentRow.ordersNumb = amountList[0].ordersNumb
        this.currentRow.clientName = amountList[0].buyerName
        this.currentRow.salesMan = amountList[0].salesManName
        this.currentRow.salesManId = amountList[0].salesManId
      } else {
        this.currentRow.ordersNumb = ''
      }
    },
    openBankAccountModal(row, field, accountCate, index) {
      this.currentRow = row
      this.currentChooseColumn = field
      if (this.payType === 1) {
        this.isShowBankAccountModal = true
        this.bankAccountModalTitle = accountCate == 'platform' ? '选择平台银行账户' : '选择用户银行账户'
        this.$refs.bankAccountModal.init(accountCate)

      } else {
        let curfield = field === 'paymentsName' ? 'recName' : 'paymentsName';
        let compNameType = 0
        this.isShowFinance = true;
        this.$refs.financeAccount.init(row, index, curfield, compNameType);
      }
    },
    chooseFinanceAccount(account, index, field) {
      // console.log(account,index, field);
      // debugger
      this.isShowFinance = false;
      let tableData = this.$refs.xTable.getTableData().fullData;

      if (tableData[index]) {
        if (field == "paymentsName") {
          tableData[index].recBank = "光大银行";
          tableData[index].recName = account.memName;
          tableData[index].recAccount = account.subAcc;
          tableData[index].recCompName = account.busiSubjectName;
        } else {
          // 清空数据
          tableData[index].payBank = "光大银行";
          tableData[index].paymentsName = account.memName;
          tableData[index].payAccount = account.subAcc;
          tableData[index].payCompName = account.busiSubjectName;
        }
      }
    },
    chooseBankAccount(bankAccount) {
      if (this.currentChooseColumn == 'paymentsName') {
        this.currentRow.payBank = bankAccount.bankName
        this.currentRow.paymentsName = bankAccount.accountName
        this.currentRow.payAccount = bankAccount.accountNum
      } else {
        this.currentRow.recBank = bankAccount.bankName
        this.currentRow.recName = bankAccount.accountName
        this.currentRow.recAccount = bankAccount.accountNum
      }
      this.isShowBankAccountModal = false
      this.$refs.xTable.clearValidate(this.currentChooseColumn)
    },
    closeBankAccount() {
      console.log('closeBankAccount')
      this.isShowBankAccountModal = false
    },
    inputPayAmountEvent(row) {
      if (isNotEmpty(row.payAmount) && row.ordersNumb == ' ') {
        row.ordersNumb = null
      }
      // if (isNaN(parseFloat(row.payAmount))) {
      //     row.payAmount = null
      // }
      //从订单进入创建,  没有关联金额, 输入付款金额保存到关联金额
      if (!this.canInsert && isNotEmpty(row.payAmount)) {
        row[this.amountListName][0].aboutAmount = row.payAmount
      }
      this.$refs.xTable.clearValidate('payAmount')
      this.updateFooterEvent()
    },
    async validEvent() {
      const errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
      return errMap ? false : true
    },
    uploadFile() {
      alert('上传附件')
    },
    async submitEvent() {
      this.isSubmit = true;
      this.createAction = this.payType === 1 ? "saveFlowForPaymentBuyer" : "saveFlowForPaymentSeller";
      this.$refs.xTable.updateStatus()
      let sts = await this.validEvent()
      if (!sts) {
        this.$XModal.message({
          status: "error",
          message: "校验不通过！"
        });
        return
      }
      let table = this.$refs.xTable.getTableData()

      if (table.tableData.length == 0) {
        this.$XModal.message({
          message: "请先添收付款"
        });
        return
      }
      let errMsgRow = "";
      let isErr = false;
      let isSameCompMsgRow = "";
      let isSameCompErr = false;
      table.fullData.forEach((item, index) => {
        if (item.payAccount == item.recAccount) {
          isErr = true;
          errMsgRow = `${index + 1},`;
        }
        if (item.payCompName != item.recCompName) {
          isSameCompErr = true;
          isSameCompMsgRow = `${index + 1},`;
        }
      });
      if (isErr && this.payType === 0) {
        this.$XModal.message({
          message: `序号${errMsgRow}付款人与收款人子账户不能一致`,
        });
        return;
      }
      if (isSameCompErr && this.payType === 0) {
        this.$XModal.message({
          message: `序号${isSameCompMsgRow}付款人与收款人所属公司不一致`,
        });
        return;
      }

      let rows = []
      let outParamsObj = {};
      if (this.payType === 1) {
        table.fullData.forEach(item => {
          if (isEmpty(item[this.amountListName]) && isNotEmpty(item.ordersNumb)) {
            //导入复制的少了 关联的列表
            item[this.amountListName] = [{
              ordersNum: item.ordersNumb,
              ordersNumb: item.ordersNumb,
              aboutAmount: item.payAmount
            }]
          }
          let row = Object.assign(item)
          row.addTime = this.$utils.timestamp(this.$utils.toStringDate(row.addTime))
          row.usedAmount = 0
          // Math.round(counts * 100) / 100;
          if (row[this.amountListName].length == 1 && (row[this.amountListName][0].ordersNumb == '' || row[this.amountListName][0].ordersNumb == null)) {
            row[this.amountListName] = []
          } else {
            row[this.amountListName].forEach(aboutOrder => {
              row.usedAmount = Math.round(row.usedAmount * 100) / 100 + Math.round(aboutOrder.aboutAmount * 100) / 100
            })
          }
          row.unusedAmount = Math.round(row.payAmount * 100) / 100 - Math.round(row.usedAmount * 100) / 100
          rows.push(row);
          outParamsObj.paymentList = rows;
        });
      } else {
        // 线上支付  参数重传
        rows = {};
        rows.title = this.formData.title;
        rows.applyTime = this.$utils.timestamp(
            this.$utils.toStringDate(this.formData.applyTime)
        );
        rows.detailList = [];
        table.fullData.forEach((item) => {
          let paramesObj = {};
          paramesObj.paymentType = 1; // 付款2 收款1
          paramesObj.clientName = item.clientName;
          paramesObj.compName = item.compName;
          paramesObj.note = item.note;
          paramesObj.payAccount = item.payAccount;
          paramesObj.payAmount = item.payAmount;
          paramesObj.paymentsName = item.paymentsName;
          paramesObj.platformCompanyId = item.platformCompanyId;
          paramesObj.recAccount = item.recAccount;
          paramesObj.recName = item.recName;
          paramesObj.salesMan = item.salesMan;
          paramesObj.salesManId = item.salesManId;
          paramesObj.fileUuidList = item.fileUuidList;
          paramesObj.rateManage = item.rateManage;
          paramesObj.isDraw = item.isDraw;
          paramesObj.drawBank = item.drawBank;
          paramesObj.drawAccount = item.drawAccount;
          rows.detailList.push(paramesObj);
          if (
              item.ordersBuyerAmountList &&
              item.ordersBuyerAmountList.length > 0
          ) {
            paramesObj.ordersList = item.ordersBuyerAmountList;
          } else if (
              item.ordersSellerAmountList &&
              item.ordersSellerAmountList.length > 0
          ) {
            paramesObj.ordersList = item.ordersSellerAmountList;
          } else if (
              item.ordersSellerLv2sAmountList &&
              item.ordersSellerLv2sAmountList.length > 0
          ) {
            paramesObj.ordersList = item.ordersSellerLv2sAmountList;
          }
          if (paramesObj.ordersList && paramesObj.ordersList.length > 0) {
            paramesObj.ordersList = paramesObj.ordersList.map((i) => {
              return Object.assign(i, {
                aboutAmount: item.payAmount
              });
            });
          }

        });
        outParamsObj.onlinePaymentVo = rows;
        outParamsObj.payType = 1; // 1线上
      }


      showLoading()
      let that = this;
      setTimeout(() => {
        if (!this.isErrMap) {
          this.$XModal.message({
            status: "error",
            message: "校验不通过！"
          });
          return
        }
        let uploadtable = this.$refs.fileTable.getTableData().tableData;
        outParamsObj.attachFile = uploadtable[0].fileUuidList;
        outParamsObj.applyTime = this.$utils.timestamp(
            this.$utils.toStringDate(this.formData.applyTime)
        );
        outParamsObj.instanceName = this.formData.instanceName;
        outParamsObj.instanceNum = this.formData.instanceNum;
        outParamsObj.applyUserId = this.formData.applyUserId;
        outParamsObj.leaderId = this.formData.leaderId;
        outParamsObj.managerId = this.formData.managerId;
        outParamsObj.reterenceId = this.formData.reterenceId;
        outParamsObj.flowTempletId = this.flowTempletId;
        if (this.payType === 1) {
          // 线下不变
          $api.flowInstance.saveFlowForPaymentBuyer
              .POST({
                data: outParamsObj,
              })
              .then((res) => {
                hideLoading();
                if (res.status === 1) {
                  this.$XModal.message({
                    status: "success",
                    message: '提交成功'
                  })
                  this.tableData = []
                  this.$emit('close')
                } else if (res.status == 0) {
                  showFailMsgList(res.data)
                } else {
                  that.$XModal.alert({
                    message: res.message ? res.message : "接口异常",
                    status: "error",
                  });
                }
              });
        } else {
          $api.flowInstance.saveFlowForPaymentSeller
              .POST({
                data: outParamsObj,
              })
              .then((res) => {
                hideLoading();
                if (res.status === 1) {
                  let mesTxt =
                      this.payType === 1 ? "提交成功" : "提交成功，待银行处理";
                  this.$XModal.message({
                    status: "success",
                    message: mesTxt
                  });
                  this.tableData = [];
                  this.$emit("close");
                } else if (res.status == 0) {
                  showFailMsgList(res.data);
                } else {
                  that.$XModal.alert({
                    message: res.message ? res.message : "接口异常",
                    status: "error",
                  });
                }
              });
        }

        this.$emit("init");
      }, 100);
    },
    footerCellClassName({
                          $rowIndex,
                          column,
                          columnIndex
                        }) {
      return 'footer-cell'
    },
    footerMethod({
                   columns,
                   data
                 }) {
      return paymentFooter({
        columns,
        data,
        rowName: '合计'
      })
    },
    updateFooterEvent() {
      this.$refs.xTable.updateFooter()
    },
    async initPlatCompMap() {
      if (isEmpty(this.platformCompMap)) {
        let res = await $api.department.get("listCompany")
        let map = {}
        res.data.rows.forEach(item => {
          map[item.name] = item.id
        })
        this.platformCompMap = map
      }
    }
  },
};
</script>
<style>
.my-dropdown4 {
  width           : 600px;
  height          : 300px;
  background-color: #fff;
  border          : 1px solid #dcdfe6;
  box-shadow      : 0 0 6px 2px rgba(0, 0, 0, 0.1);
}

.link-text {
  color      : #2D8CF0;
  font-size  : 14px;
  font-family: Roboto;
  font-weight: 400;
}

.placeholder {
  color         : #ddd;
  font-size     : 12px;
  line-height   : 100%;
  vertical-align: middle;
}

table .vxe-input--extra-suffix {
  /* display: none !important; */
}
</style>
